import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useChangeOldPasswordRequestMutation } from "@/services/api";
import { useAlert } from "@/shared/hooks";
import type { ChangeOldPasswordFormValues } from "../types";
import { getChangeOldPasswordSchema } from "../schema";

export const useChangeOldPasswordForm = () => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const { t } = useTranslation();
  const [changeOldPassword, { isLoading }] = useChangeOldPasswordRequestMutation();
  const { callSuccess } = useAlert();

  const formApi = useForm<ChangeOldPasswordFormValues>({
    resolver: yupResolver(getChangeOldPasswordSchema()),
    mode: "onBlur",
  });

  const handleOk = () => {
    const values = formApi.getValues();

    changeOldPassword({ oldPassword: values.oldPassword, newPassword: values.newPassword })
      .unwrap()
      .then(() => {
        callSuccess({ text: t("settingsPage.general.changeSuccess") });
        formApi.reset();
        setIsConfirmModalOpen(false);
      })
      .catch((err) => {
        setIsConfirmModalOpen(false);
        formApi.setError("oldPassword", {
          message: err.message,
        });
      });
  };

  const onClickSubmit = async () => {
    const isValid = await formApi.trigger();

    if (isValid) {
      setIsConfirmModalOpen(true);
    }
  };

  const handleCancel = () => {
    setIsConfirmModalOpen(false);
  };

  return {
    formApi,
    onClickSubmit,
    isLoading,
    isConfirmModalOpen,
    handleCancel,
    handleOk,
  };
};
